<app-navbar></app-navbar>

<div class="min-h-screen bg-section pt-24 pb-20 px-4 sm:px-6 lg:px-8 font-serif text-body-text selection:bg-btn/30 relative overflow-hidden">
  
  <!-- Botanical Decoration -->
  <div class="absolute -top-6 -left-6 sm:-top-12 sm:-left-12 w-32 h-32 sm:w-64 sm:h-64 md:w-96 md:h-96 opacity-40 sm:opacity-60 pointer-events-none z-0">
    <img src="amla-top-left.jpg" alt="Amla Branch" class="w-full h-full object-contain mix-blend-multiply aspect-square transform -rotate-12">
  </div>

  <div class="max-w-7xl mx-auto relative z-10">
    
    <div class="text-center mb-12 animate-fade-in">
      <h1 class="text-4xl sm:text-5xl font-serif text-heading mb-4">Your Saved Rituals</h1>
      <div class="w-24 h-px bg-btn mx-auto opacity-50"></div>
      <p class="mt-6 text-muted font-serif italic text-lg">"The apothecary treasures you've chosen for your journey."</p>
    </div>

    <!-- Empty State -->
    <div *ngIf="wishlist().length === 0" class="text-center py-20 space-y-8 animate-fade-in bg-white border border-[#E5DDD5] rounded-sm p-12 shadow-sm max-w-2xl mx-auto">
      <div class="w-24 h-24 mx-auto border border-[#E5DDD5] rounded-full flex items-center justify-center bg-card">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-10 h-10 text-btn">
          <path stroke-linecap="round" stroke-linejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" />
        </svg>
      </div>
      <h2 class="text-2xl font-serif text-heading">Your wishlist is currently a void</h2>
      <p class="text-muted max-w-sm mx-auto">Begin exploring our apothecary to find botanical treasures that resonate with your spirit.</p>
      <a routerLink="/home" class="inline-block px-10 py-4 bg-heading text-white font-serif uppercase text-xs tracking-[0.2em] hover:bg-heading-dark transition-all rounded-sm shadow-lg">
        Explore Apothecary
      </a>
    </div>

    <!-- Product Grid -->
    <div *ngIf="wishlist().length > 0" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
      <div 
        *ngFor="let product of wishlist(); let i = index" 
        class="group bg-white rounded-sm border border-[#E5DDD5] overflow-hidden hover:shadow-2xl transition-all duration-500 hover:-translate-y-1 flex flex-col relative animate-fade-in-up"
        [style.animationDelay]="i * 100 + 'ms'"
      >
        
        <!-- Image Area -->
        <div class="aspect-[4/5] relative overflow-hidden bg-card cursor-pointer shimmer" [routerLink]="['/product', product.id]">
          <img 
            [src]="getImageUrl(product.image)" 
            [alt]="product.name"
            loading="lazy"
            class="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-[1.5s] ease-out"
          >
          
          <!-- Remove from Wishlist -->
          <button 
            (click)="removeFromWishlist(product)"
            class="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full bg-white/80 backdrop-blur-sm border border-[#E5DDD5]/50 text-red-500 hover:bg-white transition-all duration-300 shadow-sm z-20"
          >
             <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
               <path stroke-linecap="round" stroke-linejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" />
             </svg>
          </button>
        </div>

        <!-- Content Area -->
        <div class="p-5 flex flex-col flex-1 space-y-4">
          <div class="flex items-center justify-between text-[10px] text-muted font-serif uppercase tracking-widest">
            <span>{{ product.category }}</span>
          </div>

          <div class="space-y-1">
            <h3 class="font-serif text-lg text-heading leading-tight group-hover:text-btn transition-colors cursor-pointer" [routerLink]="['/product', product.id]">
              {{ product.name }}
            </h3>
            <div class="flex items-center gap-2">
              <span class="font-bold text-heading">{{ getDiscountedPrice(product) | currency:'INR' }}</span>
              <span *ngIf="product.discount > 0" class="text-sm text-muted line-through decoration-btn/50">
                {{ product.price | currency:'INR' }}
              </span>
            </div>
          </div>

          <button 
            class="w-full py-3 bg-heading text-white font-serif uppercase text-[10px] tracking-widest hover:bg-heading-dark transition-all rounded-sm shadow-md"
            (click)="addToCart(product)"
            [disabled]="!product.isInStock"
          >
            {{ product.isInStock ? 'Add to Ritual' : 'Sold Out' }}
          </button>
        </div>
      </div>
    </div>

  </div>
</div>
